import { useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import Logo from "./Logo";

export default function WelcomeGate() {
    const { setDeliveryType } = useCart();
    const navigate = useNavigate();

    const choose = (t) => {
        setDeliveryType(t);
        navigate("/menu", { replace: false });
    };

    return (
        <div
            data-testid="welcome-gate"
            className="fixed inset-0 z-[60] overflow-y-auto"
            style={{
                background:
                    "linear-gradient(160deg, #5a2d0c 0%, #d35400 55%, #f0a050 100%)",
            }}
        >
            <div className="min-h-screen flex flex-col items-center justify-center px-5 py-10">
                <div className="text-center text-white max-w-md w-full fade-up">
                    <div className="flex justify-center mb-5">
                        <Logo size={96} />
                    </div>
                    <h1 className="text-4xl sm:text-5xl font-black tracking-tight">
                        أهلاً بك في تسالي سكة 10
                    </h1>
                    <p className="mt-3 text-lg opacity-95">
                        كيف تحب نوصلك طلبك اليوم؟
                    </p>

                    <div className="mt-8 grid grid-cols-1 gap-3">
                        <button
                            onClick={() => choose("car")}
                            data-testid="welcome-choose-car"
                            className="bg-white text-text-main rounded-2xl p-5 text-start hover:bg-[#FFF1DD] active:scale-[0.98] transition-all shadow-lg group"
                        >
                            <div className="flex items-center gap-4">
                                <div className="w-14 h-14 rounded-2xl bg-brand text-white flex items-center justify-center text-2xl group-hover:scale-110 transition">
                                    <i className="fa-solid fa-car" />
                                </div>
                                <div className="flex-1">
                                    <div className="font-extrabold text-xl">توصيل للسيارة</div>
                                    <div className="text-text-muted text-sm mt-0.5">
                                        نسلمك طلبك مباشرة لسيارتك
                                    </div>
                                </div>
                                <i className="fa-solid fa-arrow-left text-brand text-xl" />
                            </div>
                        </button>

                        <button
                            onClick={() => choose("location")}
                            data-testid="welcome-choose-location"
                            className="bg-white text-text-main rounded-2xl p-5 text-start hover:bg-[#FFF1DD] active:scale-[0.98] transition-all shadow-lg group"
                        >
                            <div className="flex items-center gap-4">
                                <div className="w-14 h-14 rounded-2xl bg-[var(--mint)] text-white flex items-center justify-center text-2xl group-hover:scale-110 transition">
                                    <i className="fa-solid fa-location-dot" />
                                </div>
                                <div className="flex-1">
                                    <div className="font-extrabold text-xl">توصيل للموقع</div>
                                    <div className="text-text-muted text-sm mt-0.5">
                                        نوصل طلبك إلى أي عنوان تختاره
                                    </div>
                                </div>
                                <i className="fa-solid fa-arrow-left text-brand text-xl" />
                            </div>
                        </button>
                    </div>

                    <div className="mt-8 text-sm opacity-80">
                        <i className="fa-solid fa-clock ms-1" /> توصيل سريع • دفع كاش أو عند الاستلام
                    </div>
                </div>
            </div>
        </div>
    );
}
